import { QueryKeys } from "@/constants/Query";
import axiosInstance from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";

interface DocumentParams {
  resourceId?: string;
  resourceType?: string;
  extensionUrl?: string;
  extensionValueType?: string;
  path: string;
  enabled?: boolean;
  patientId: string;
}

export const useDocument = ({
  patientId,
  resourceId,
  resourceType,
  extensionUrl,
  extensionValueType,
  path,
  enabled = true,
}: DocumentParams) => {
  const params = {
    resourceId,
    resourceType,
    extensionUrl,
    extensionValueType,
    path,
  };

  return useQuery({
    queryFn: async () => {
      const response = await axiosInstance.get<Blob>("/storage/get", {
        params,
        responseType: "blob",
      });

      return response.data;
    },
    queryKey: QueryKeys.Patient.Files.RESOURCE({
      patientId,
      resourceType,
      resourceId,
    }),
    enabled,
  });
};
